/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Link} from 'components/ui';
import {Content} from './style';

const PageError = (props: {
  status: string;
  text: string;
  button: {
    path: string;
    text: string;
  };
}): JSX.Element => {
  const {status, text, button} = props;

  return (
    <Content>
      <h1>{status}</h1>
      <p>{text}</p>
      <Link to={button.path}>{button.text}</Link>
    </Content>
  );
};

export default PageError;